import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  initialMinutes?: number;
  initialSeconds?: number;
  className?: string;
  compact?: boolean;
}
export function CountdownTimer({
  initialMinutes = 30,
  initialSeconds = 0,
  className = '',
  compact = false
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60 + initialSeconds);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  if (compact) {
    return <span className={`font-bold tabular-nums ${className}`} style={{
      fontFamily: 'var(--font-heading)'
    }} data-id="element-2" data-mp="15fqwu1ruxomv">
        {pad(minutes)}:{pad(seconds)}
      </span>;
  }
  return <div className={`flex items-center gap-2 ${className}`} data-id="element-3" data-mp="1c0op0fy0njq7">
      <div className="flex flex-col items-center" data-id="element-4" data-mp="1bzdkgdwqy7y1">
        <div className="bg-white text-red-600 font-bold text-2xl md:text-3xl w-14 h-14 flex items-center justify-center rounded-lg shadow-md tabular-nums" style={{
        fontFamily: 'var(--font-heading)'
      }} data-id="element-5" data-mp="1h0b1gn60svxy">
          {pad(minutes)}
        </div>
        <span className="text-xs text-white mt-1 uppercase tracking-wide" data-id="element-6" data-mp="1urg7c6zzekgq">
          Min
        </span>
      </div>
      <div className="text-white font-bold text-2xl mb-4" data-id="element-7" data-mp="1zqiz4pqyau6r">:</div>
      <div className="flex flex-col items-center" data-id="element-8" data-mp="1zs3xyrkaszaf">
        <div className="bg-white text-red-600 font-bold text-2xl md:text-3xl w-14 h-14 flex items-center justify-center rounded-lg shadow-md tabular-nums" style={{
        fontFamily: 'var(--font-heading)'
      }} data-id="element-9" data-mp="1l0lhksnj12qj">
          {pad(seconds)}
        </div>
        <span className="text-xs text-white mt-1 uppercase tracking-wide" data-id="element-10" data-mp="2ihsjxv6695dn">
          Seg
        </span>
      </div>
    </div>;
}